import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizerModule } from '@epicuro-next/ataraxia/dom-sanitizer';
import { RemoveMarkdownPipe } from '@epicuro-next/ataraxia/markdown';
import { dynamicElementsTexMarkdowntKey } from '@epicuro-next/constants/dynamic-elements';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { MarkdownModule } from 'ngx-markdown';

@DynamicComponentRegister(dynamicElementsTexMarkdowntKey, true)
@Component({
  selector: 'epc-dynamic-elements-text-markdown',
  templateUrl: './editable-markdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MarkdownModule, DomSanitizerModule, RemoveMarkdownPipe, AsyncPipe],
  styleUrls: ['./editable-markdown.component.scss'],
})
export class DynamicElementsEditableTextMarkdownComponent {
  @Input() public text = '';
}

DontTreeShake(DynamicElementsEditableTextMarkdownComponent);
